import React, { FC } from 'react';
import { useApplicationContext } from 'components/hooks/UseApplicationContext';
import { SourceInfosSearchItemCompactList } from './SourceInfosSearchItemCompactList';
import { EmptyLinePlaceholder } from 'components/common/EmptyLinePlaceholder';
import { clipPaginateList } from 'components/pages/search/clip-list';
import { SeeMoreLinkCompany } from 'components/pages/search/SeeMoreLink';
import { useTranslation } from 'react-i18next';
import { FeatureTracked } from 'models/tracking';
import { GetSearchResponse } from 'services/ApiService/SgmSearch/SgmSearchApiClient';

const MAX_COMPANIES = 3;

type QuicksearchCompanyResultsProps = {
    companySearchResultItems: NonNullable<Required<GetSearchResponse['company']>>;
    isLoading: boolean;
    openInNew: boolean;
};

export const QuicksearchCompanyResults: FC<
    QuicksearchCompanyResultsProps
> = ({ companySearchResultItems, isLoading, openInNew }) => {
    const { t: translation } = useTranslation('service-list');
    const { canSearchPersonsAndCompanies } = useApplicationContext();
    const { clipped, total, hasMore } = clipPaginateList(companySearchResultItems, MAX_COMPANIES);
    if (!canSearchPersonsAndCompanies) {
        return <></>;
    }
    if (!isLoading && total === 0) {
        return <></>;
    }
    return (
        <div className="mt-5">
            <h4 className="quicksearch-title text-secondary pb-2 mb-0">
                {translation('companyResults')}
            </h4>
            {isLoading ? <EmptyLinePlaceholder count={MAX_COMPANIES} /> : null}
            {!isLoading ? (
                <SourceInfosSearchItemCompactList
                    data={clipped}
                    useIcon="business"
                    feature={FeatureTracked.OpenCompany}
                />
            ) : null}
            {!isLoading && hasMore ? (
                <SeeMoreLinkCompany total={total} openInNew={openInNew} />
            ) : null}
        </div>
    );
};
